module.exports = __webpack_public_path__ + "static/media/venetian03.346e3fee.png";